import React from 'react';

const ClipboardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .415.162.798.425 1.082.263.285.622.467 1.025.467a1.5 1.5 0 0 0 1.5-1.5c0-.231-.035-.454-.1-.664m-5.8 0A48.108 48.108 0 0 0 3.453 3.916A2.25 2.25 0 0 0 1.5 6.108V18.75A2.25 2.25 0 0 0 3.75 21h5.25" />
  </svg>
);

export default ClipboardIcon;